export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";